import Vue from 'vue'

const state = {
    isListLoading: false,
    isCreateLoading: false,
    list: [],
    listSettings: {
        currentPage: 1,
        numberOfPages: 1,
        maxPerPage: 25
    }
};

const getters = {
    isListLoading: state => {
        return state.isListLoading;
    },
    isCreateLoading: state => {
        return state.isCreateLoading;
    },
    codes: state => {
        return state;
    },
    listSettings: state => {
        return state.listSettings;
    }
};

const mutations = {
    startListLoading(state) {
        Vue.set(state, 'isListLoading', true);
    },
    startCreateLoading(state) {
        Vue.set(state, 'isCreateLoading', true);
    },
    stopCreateLoading(state) {
        Vue.set(state, 'isCreateLoading', false);
    },
    setList(state, list) {
        Vue.set(state, 'list', list);
        Vue.set(state, 'isListLoading', false);
        if (list.results.length > 0) {
            Vue.set(state, 'list', list.results);
            Vue.set(state.listSettings, 'currentPage', list.current_page);
            Vue.set(state.listSettings, 'maxPerPage', list.max_per_page);
            Vue.set(state.listSettings, 'numberOfPages', list.number_of_pages);
        } else {
            Vue.set(state, 'list', []);
        }
    },
    cancelCode(state, code) {
        Vue.set(state, 'list', state.list.filter(otherCode => code.codeId !== otherCode.codeId));
        Vue.set(state, 'isListLoading', false);
    }
};

const actions = {
    /**
     * Set max number of items in list of vouchers
     * @param getters
     * @param data
     * @returns {Promise}
     */
    async listSetItems ({}, data) {
        return new Promise((resolve) => {
            Vue.set(state.listSettings, 'maxPerPage', data);

            resolve();
        });
    },

    /**
     * Set page in list of vouchers
     * @param getters
     * @param data
     * @returns {Promise}
     */
    async listSetPage ({}, data) {
        return new Promise((resolve) => {
            Vue.set(state.listSettings, 'currentPage', data);
            resolve();
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/code.js